module.exports = __webpack_public_path__ + "img/logo.558df05d.png";